import React from 'react';
import { get } from 'lodash';
import { PauseModal, PauseModalBody, PauseModalTitle } from '../../../../components/PauseModal';
import { PauseTypography } from '../../../../components/PauseTypography';
import { Check } from '../../../../../assets/icons/feather/components';
import { colors } from '../../../../components/PauseTheme/colors';

const features = [
  'Apply for leaves on desktop or mobile',
  'Set teams and assign approvers',
  'Customise your policy to suit your culture',
  'Use Pause without ever leaving Slack',
  'Auto-decline events on Calendar when on leave',
  'Mark your calendar so your team is clued in',
  'Set public holidays for distributed teams',
  'Export data for payroll processing',
  'Access in-app chat support anytime',
];
const Feature = ({ feature }) => (
  <div css={(theme) => ({
    display: 'grid',
    gridAutoFlow: 'columns',
    gridTemplateColumns: '24px auto',
    gridGap: theme.spacing(1),
    alignItems: 'center',
  })}
  >
    <div>
      <Check height="20" width="20" stroke={colors.green.dark} />
    </div>
    <div css={(theme) => ({
      borderBottom: `1px solid ${get(theme, 'palette.pause.background.dark')}`,
      paddingBottom: theme.spacing(1),
    })}
    >
      <PauseTypography>{feature}</PauseTypography>
    </div>
  </div>
);

type PlanDetailsProps = {
  open:boolean,
  onClose:() => any,
}
export const PlanDetailsCard = ({
  open = false,
  onClose = () => null,
}: PlanDetailsProps) => (
  <PauseModal
    width="25vw"
    open={open}
    onClose={onClose}
  >
    <PauseModalTitle
      title="$1 per user/month"
      onClose={onClose}
    />
    <PauseModalBody>
      {features.map((feature) => (
        <div
          key={feature}
          css={(theme) => ({
            padding: theme.spacing(1, 0),
          })}
        >
          <Feature feature={feature} />
        </div>
      ))}
    </PauseModalBody>
  </PauseModal>
);
